module.exports = __webpack_public_path__ + "static/media/payment-logo-band.b567dc4d.png";